import Container from '@components/common/layout'
import Image from 'next/image'
import Link from 'next/link'

interface PartnerInfo {
  name: string
  image: string
  slug: string
}

export const partners = {
  aws: {
    name: 'Amazon Web Services',
    image: 'aws.svg',
    slug: 'aws',
  },
  google: {
    name: 'Google Cloud',
    image: 'google_cloud.svg',
    slug: 'google',
  },
  microsoft: {
    name: 'Microsoft',
    image: 'microsoft.svg',
    slug: 'microsoft',
  },
  snowflake: {
    name: 'Snowflake',
    image: 'snowflake.svg',
    slug: 'snowflake',
  },
  databricks: {
    name: 'Databricks',
    image: 'databricks.svg',
    slug: 'databricks',
  },
}

const PartnerRow = ({
  theme,
  partnerInfo,
}: {
  theme: 'light' | 'dark'
  partnerInfo: PartnerInfo[]
}) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-${partnerInfo.length}`}>
      {partnerInfo.map(({ name, image, slug }) => (
        <div key={name} className='h-[180px]'>
          <div className='flex h-[60%] items-center justify-center'>
            <Image
              alt={`partner symbol for ${name}`}
              src={`/assets/png/partners/${image}`}
              width={250}
              height={50}
              className={`mx-auto max-h-16 w-[200px] object-contain object-center brightness-0 ${
                theme === 'dark' ? 'invert' : ''
              }`}
              priority
            />
          </div>
          {slug != null && slug !== '' && (
            <Link
              className='mt-8 align-bottom text-2xl font-medium underline underline-offset-4'
              href={`/partnerships/${slug}`}
            >
              {'Learn More'}
            </Link>
          )}
        </div>
      ))}
    </div>
  )
}

export const OurPartners = ({
  className,
  theme = 'dark',
}: {
  className?: string
  theme?: 'light' | 'dark'
}) => {
  const partnerInfo: PartnerInfo[] = [
    partners.aws,
    partners.google,
    partners.microsoft,
    partners.snowflake,
    partners.databricks,
  ]

  const chunkedInfo: PartnerInfo[][] = []

  const chunkSize = 3
  for (let i = 0; i < partnerInfo.length; i += chunkSize) {
    chunkedInfo.push(partnerInfo.slice(i, i + chunkSize))
  }

  const textClassName = theme === 'dark' ? 'text-white' : 'text-black'

  return (
    <Container className={className}>
      <div
        className={`${textClassName} mx-auto max-w-[960px] py-16 text-center`}
      >
        <h2 className='text-2xl font-medium xs:text-5xl sm:text-7xl'>
          Our Partnerships
        </h2>
        <p className='mt-16 text-xl xs:text-2xl sm:text-4xl'>
          V2 works closely with its partners to bring measurable business
          outcomes to customers, leveraging a range of capabilities.
        </p>

        <div className='container mx-auto pt-8'>
          {chunkedInfo.map((chunk, rowIndex) => (
            <PartnerRow key={rowIndex} theme={theme} partnerInfo={chunk} />
          ))}
        </div>
      </div>
    </Container>
  )
}
